import { useReactiveSpot } from '@frontend/spot/events';
import { Spot } from '@frontend/spot/types';

import { useScreen } from '../useScreen';

interface ViewProps {
    spot: Spot | null;
    isLoading: boolean;
    onSubmit: () => void;
}

const useContinueToLocation = (): ViewProps => {
    const { wizardData, onSubmit } = useScreen();
    const { package: pkg } = wizardData;
    const { spot, initialising, isLoading } = useReactiveSpot({ spotId: pkg?.spot_id ?? undefined });

    return {
        spot,
        isLoading: initialising || isLoading,
        onSubmit
    };
};

export default useContinueToLocation;
